<template><div><h1 id="ereigniskostenstruktur" tabindex="-1"><a class="header-anchor" href="#ereigniskostenstruktur"><span>Ereigniskostenstruktur</span></a></h1>
<p>Ereigniskostenstruktur — Stammtabelle</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In der Ereigniskostenstruktur werden die Standardpositionen und Hierarchien der Ereigniskosten zuammengestellt.</p>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Änderungen in der Ereigniskostenstruktur wirken sich nur auf die nach der Änderung zugeordneten Strukturen aus! Wird in dieser Stammtabelle ein Datensatz gelöscht, bleiben die Einträge in der Ereigniskostenerfassung unverändert und werden weiterhin angezeigt.</p>
</div>
<p>Pfad: <code v-pre>Personen → Tabellen → Ereigniskosten-Struktur</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Struktur-ID</dt>
<dd>Zeilenidentifikation der Kostenpositionen</dd>
<dt>Beschreibung</dt>
<dd>Bezeichnung des Kostenstruktur</dd>
<dt>Parent</dt>
<dd>Übergeordnete Hierarchie der Kostenposition</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


